import React from 'react';
import {Image, TouchableOpacity, View, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import LinearGradient from 'react-native-linear-gradient';
import {images} from '../../../assets/icons';
import {useBlockCardDialog} from '../../hooks/useBlockCardDialog';
import {useTheme} from '../../theme';
import {CardInfoCard} from './components/card';
import {CardInfoCardBlocked} from './components/cardBlocked';
import {Props as BaseProps} from './model';
import {themeSelector} from '../../../redux/selectors/runtime/theme';
import {VisImpFontSize, VisImpStatus} from '../../models/visuallyImpairedSettings';
import {ProfileCardBlurredLayout} from '../../../assets/images';
import {GetStyles} from './style';
import {Text} from '../text';

interface Props extends BaseProps {
  card?: string;
  dateUntil?: string;
  uscIsBlocked: boolean;
  isFinancial: boolean;
}

const cardBackgroundColors = ['#75BD7A', '#B3CD6D', '#46BED3', '#306BB3', '#5A398E', '#2F517A'];
const blockButtonIconSize = 24;

export default ({dateUntil, card, uscIsBlocked, isFinancial, showBlockButton}: Props) => {
  const theme = useTheme();
  const themeSettings = useSelector(themeSelector());
  const isVisImpActive = themeSettings.visuallyImpaired === VisImpStatus.Active;
  const isVisImpFontLarge = isVisImpActive && themeSettings.fontSize !== VisImpFontSize.Small;

  const styles = GetStyles(theme, isVisImpActive, isVisImpFontLarge, uscIsBlocked);

  const showBlockCardDialog = useBlockCardDialog();
  const CardLayout = isVisImpActive ? View : LinearGradient;

  return (
    <View style={styles.wrap}>
      {isVisImpActive ? (
        <View style={styles.tracery} />
      ) : (
        <Image source={ProfileCardBlurredLayout as any} style={styles.tracery} />
      )}
      <View style={styles.cardContainer}>
        <CardLayout colors={cardBackgroundColors} angle={90} useAngle style={styles.cardLayout}>
          {uscIsBlocked ? <CardInfoCardBlocked /> : <CardInfoCard dateUntil={dateUntil} card={card} />}
        </CardLayout>
        {!isFinancial && !uscIsBlocked && showBlockButton && (
          <View style={styles.buttonContainer}>
            <TouchableOpacity
              testID='block-card'
              activeOpacity={0.9}
              style={styles.button}
              onPress={showBlockCardDialog}>
              <images.Lock
                color={StyleSheet.flatten(styles.buttonIcon).color}
                width={blockButtonIconSize}
                height={blockButtonIconSize}
              />
              <Text type='action' style={styles.buttonText}>
                Заблокировать карту
              </Text>
            </TouchableOpacity>
          </View>
        )}
      </View>
    </View>
  );
};
